module.exports = __webpack_public_path__ + "img/support-white.0b0adf5d.svg";